<template>
	<div class="video">
		<div class="video__content">
			<div class="video__about">
				<p class="video__aboute-text">
					{{ $t('pages.publishers.sections.formats.videoContent.about.text') }}
				</p>
			</div>
			<div class="video__description">
				<BlocksPublishersFormatTabs :tabs="tabs">
					<template #tab-content-1>
						<div class="video__description-wrapper">
							<div v-for="(block, i) in formatBlocks" :key="i" class="video__description-block">
								<Icon name="lets-icons:check-fill" size="40" />
								<BlocksPublishersFormatTabBlockButtons
									v-if="$rt(block.type) === 'buttons'"
									:block="block"
									:selected-format="selectedFormat"
									@select-format="handleSelectFormat" />
								<BlocksPublishersFormatTabBlockChips
									v-if="$rt(block.type) === 'chips'"
									:block="block" />
								<BlocksPublishersFormatTabBlockList v-if="$rt(block.type) === 'list'" :block="block" />
								<BlocksPublishersFormatTabBlockText v-if="$rt(block.type) === 'text'" :block="block" />
							</div>
						</div>
					</template>
					<template #tab-content-2>
						<div class="video__description-wrapper">
							<div v-for="(block, i) in integrationBlocks" :key="i" class="video__description-block">
								<Icon name="mdi:youtube" size="40" />
								<BlocksPublishersFormatTabBlockButtons
									v-if="$rt(block.type) === 'buttons'"
									:block="block"
									:selected-format="selectedFormat"
									@select-format="handleSelectFormat" />
								<BlocksPublishersFormatTabBlockChips
									v-else-if="$rt(block.type) === 'chips'"
									:block="block" />
								<BlocksPublishersFormatTabBlockList
									v-else-if="$rt(block.type) === 'list'"
									:block="block" />
								<BlocksPublishersFormatTabBlockText
									v-else-if="$rt(block.type) === 'text'"
									:block="block" />
							</div>
						</div>
					</template>
				</BlocksPublishersFormatTabs>
			</div>
		</div>
		<BlocksPublishersFormatTabVideoExample
			:selected-format="selectedFormat"
			:formats="availableFormats"
			@change-format="handleSelectFormat" />
	</div>
</template>
<script setup lang="ts">
	type VideoBlock = {
		type: string
		title?: string
		items?: { title: string; buttons: string[] }[]
		chips?: string[]
		list?: string[]
		text?: string
	}

	const selectedFormat = ref('In-Stream')

	const handleSelectFormat = (format: string) => {
		selectedFormat.value = format
	}

	const { tm, rt } = useI18n()
	const tabs = computed(
		() => tm('pages.publishers.sections.formats.videoContent.tabs') as { title: string; soon?: string }[]
	)

	const formatBlocks = computed<VideoBlock[]>(
		() => tm('pages.publishers.sections.formats.videoContent.tabFormatsContent.blocks') as VideoBlock[]
	)

	const integrationBlocks = computed<VideoBlock[]>(
		() =>
			tm('pages.publishers.sections.formats.videoContent.tabIntegrationContent.blocks') as VideoBlock[]
	)

	const availableFormats = computed(() =>
		formatBlocks.value
			.filter((item) => rt(item.type) === 'buttons' && item.items)
			.flatMap((item) => item.items!.flatMap((group) => group.buttons.map((button) => rt(button))))
	)
</script>
<style lang="scss" scoped>
	.video {
		display: flex;
		gap: 48px;
		align-items: flex-start;

		@media (width <= 767.98px) {
			flex-direction: column-reverse;
			gap: 24px;
			align-items: center;
		}
		&__content {
			display: flex;
			flex-direction: column;
			gap: 8px;
			// flex: 0 0 50%;
			// max-width: 50%;
			width: 100%;
		}
		&__about {
			padding: 24px;
			background-color: var(--white);
			border-radius: 20px;
			&-text {
				font-size: 16px;
			}
		}
		&__description {
			display: flex;
			flex-direction: column;
			gap: 24px;
			padding: 24px;
			background-color: var(--white);
			border-radius: 20px;
			&-wrapper {
				display: flex;
				flex-direction: column;
				gap: 24px;
			}
			&-block {
				display: flex;
				gap: 16px;

				@media (width <= 767.98px) {
					flex-direction: column;
					gap: 8px;
				}
				.iconify {
					flex-shrink: 0;
					margin-top: -8px;
					color: var(--primary);

					@media (width <= 767.98px) {
						margin-top: 0;
						margin-left: -8px;
					}
				}
			}
		}
	}
</style>
